import { observable, action } from 'mobx'
import _ from 'lodash'

let DialogStore = observable({
    show: false,
})

_.assign(DialogStore, {
    showDialog: action(() => {
        DialogStore.show = true
    }),
    closeDialog: action(() => {
        DialogStore.show = false
    }),
})

export default DialogStore


// WEBPACK FOOTER //
// ./src/stores/DialogStore.js